module.exports = __webpack_public_path__ + "static/6576dd.woff";